import { render } from "./applist.vue?vue&type=template&id=d0b22520"
import script from "./applist.vue?vue&type=script&lang=js"
export * from "./applist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__